import { createAction, createSlice } from "@reduxjs/toolkit";

const handleCartSlice = createSlice({
  name: "handleCart",
  initialState: {
    data: {
      listId: [],
    },
    processing: false,
  },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    // addToCart(state, action) {
    //   state.processing = false;
    //   if (!action.payload.listId.includes(action.payload.id)) {
    //     state.data.listId = [...state.data.listId, action.payload.id];
    //   }
    // },
    // addToWishlist(state, action) {
    //   state.processing = false;
    //   const index = state.data.listId.indexOf(action.payload.id);
    //   if (index > -1) {
    //     state.data.listId = state.data.listId.filter((subValue) => {
    //       return subValue !== action.payload.id;
    //     });
    //   }
    // },
  },
});

const { name, actions, reducer } = handleCartSlice;
const handleCartAction = createAction(name);
// const addToCartAction = actions.addToCart;
// const addToWishlistAction = actions.addToWishlist;

export {
  handleCartAction,
  // addToCartAction,
  // addToWishlistAction,
  actions as handleCartActions,
  reducer as handleCartReducer,
};
